import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const faqs = [{
  q: 'Is this a physical product?',
  a: `No. ${PRODUCT_NAME} is a 100% digital professional teaching resource.`
}, {
  q: 'Who is this for?',
  a: 'Physical Education teachers who already know how to teach and want practical, ready-to-use resources.'
}, {
  q: 'Is this a certification program?',
  a: 'No. It is a teaching and planning resource, not a certification or teacher-training program.'
}, {
  q: 'Is this just a collection of PE games?',
  a: 'No. It includes lesson structures, activities, skill progressions, fitness sessions, management tools, adaptations and assessment resources.'
}, {
  q: 'Do I need to build the lessons myself?',
  a: 'No. The system includes ready-to-teach structures and resources you can use or adapt.'
}, {
  q: 'Can I adapt the material?',
  a: 'Yes. You can adjust activities according to ability, group size, space, equipment and time.'
}, {
  q: 'Does it work with limited equipment?',
  a: 'Yes. Low-equipment and no-equipment options are included.'
}, {
  q: 'Does it include assessment tools?',
  a: 'Yes. Practical observation, assessment and progress-tracking resources are included.'
}, {
  q: "Is it tied to one country's curriculum?",
  a: 'No. It is designed as an international English-language teaching resource.'
}, {
  q: 'How will I receive it?',
  a: "You'll receive immediate digital access after purchase."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-6 border-b border-brand-line" data-id="element-39" data-mp="wxw4ox4wxngl">
      <div className="max-w-3xl mx-auto" data-id="element-40" data-mp="wvt6vqxiqq1b">
        <h2 className="font-display text-2xl sm:text-3xl text-brand-navy text-center mb-3" data-id="element-41" data-mp="iy4mek7d5kws">
          Frequently Asked Questions
        </h2>

        <div className="space-y-1.5" data-id="element-42" data-mp="n22liuwouvpu">
          {faqs.map((faq, i) => <div key={faq.q} className="bg-brand-cream border border-brand-line rounded-lg overflow-hidden" data-id="element-43" data-mp="2pnezn56cjppd" data-mpi={i}>
              <button type="button" onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-3.5 py-2.5 text-left flex justify-between items-center gap-3 hover:bg-brand-green/5 transition-colors duration-150 ease-out" aria-expanded={openIndex === i} aria-controls={`faq-panel-${i}`} data-id="element-44" data-mp="2fwtut002xoy0">
                <span className="font-heading font-bold text-[13px] sm:text-sm text-brand-navy leading-snug" data-id="element-45" data-mp="2yn1qwy5d3f4p">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-4 h-4 text-brand-green shrink-0 transition-transform duration-200 ease-out ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-46" data-mp="2ulghxnvy7kzs" />
              </button>
              {openIndex === i && <div id={`faq-panel-${i}`} className="px-3.5 pb-2.5 text-[13px] text-brand-slate font-medium leading-snug" data-id="element-47" data-mp="2q3zqtqr1wp7">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}